import React from 'react'

const DiscogsCallbackPage =  () => (
  <main>
    <p>here we are</p>
    <p>{window.location.search}</p>
  </main>
)

export default DiscogsCallbackPage